import React, { ChangeEvent, useState } from "react";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { StatusCode } from "api/protocols";
import { showError, showSuccess } from "redux/actions/ui";
import { useAppDispatch } from "hooks/redux";

import Page from "components/page/Page";
import Card from "components/card/Card";
import Form from "components/form/Form";
import FormLayout from "components/form/FormLayout";
import { handleChangeEventInput } from "helpers/Helpers";
import Input from "components/form/input/Input";
import TextField from "components/form/textField/TextField";
import { ButtonNew as Button } from "components/buttonNew";
import {
  IPostAccommodationBuilding,
  PostAccommodationBuilding,
} from "api/rpc/2024-04/facilityAdmin/accommodation/building";

export function BuildingNew() {
  const history = useHistory();
  const dispatch = useAppDispatch();
  const { t } = useTranslation();

  const [building, setBuilding] = useState<IPostAccommodationBuilding>({
    title: undefined,
    code: "",
    description: "",
  });

  async function createAccommodationBuilding() {
    const buildingRes = await PostAccommodationBuilding(
      {
        title: building?.title,
        code: building?.code,
        description: building?.code,
      },
      true,
    );

    if (buildingRes.status !== StatusCode.OK) {
      dispatch(showError("Error creating new building"));
      return;
    }

    dispatch(showSuccess(t("Successfully created building")));
    history.push("/admin/accommodation/configuration/locations");
  }

  return (
    <Page
      title={t("Add new location")}
      breadcrumbs={[
        { label: t("Accommodations"), url: "/admin/accommodation" },
        { label: t("Property Configuration"), url: "/admin/accommodation/configuration/locations" },
        { label: t("Locations"), url: "/admin/accommodation/configuration/locations" },
      ]}
    >
      <Form>
        <Card title="Location Details">
          <div style={{ paddingLeft: "24px", paddingRight: "24px" }}>
            <hr style={{ marginBottom: "0px" }} />
          </div>
          <Card.Section>
            <FormLayout>
              <FormLayout.Group alignStart>
                <div>
                  <Input
                    value={building.title}
                    label={t("Name of building or location")}
                    id="title"
                    onChange={e => handleChangeEventInput(e, building, setBuilding)}
                    placeholder={t("Enter building or location name")}
                  />
                </div>

                <Input
                  value={building.code}
                  label={t("Code")}
                  id="code"
                  onChange={e => handleChangeEventInput(e, building, setBuilding)}
                  placeholder={t("I.e., ZONEB, ABC, etc.")}
                  helpText={t("Recommended: 3-4 characters–no space between.")}
                />
              </FormLayout.Group>

              <FormLayout.Group>
                <div>
                  <TextField
                    label={t("Description")}
                    id="description"
                    value={building?.description}
                    onChange={(e: ChangeEvent<HTMLTextAreaElement>) => handleChangeEventInput(e, building, setBuilding)}
                    maxLength={300}
                    characterCountBottom
                    rows={5}
                    placeholder={t("Enter location or building description")}
                  />
                </div>
              </FormLayout.Group>
            </FormLayout>
          </Card.Section>
        </Card>

        <FormLayout>
          <FormLayout.Group>
            <div></div>
            <div></div>
            <div className="flex justify-end mt-3">
              <Button type="secondary" onClick={() => history.push("/admin/accommodation/configuration/locations")}>
                {"Cancel"}
              </Button>

              <Button type="primary" onClick={() => createAccommodationBuilding()}>
                {"Publish"}
              </Button>
            </div>
          </FormLayout.Group>
        </FormLayout>
      </Form>
    </Page>
  );
}
